<!-- <ngx-loading-bar [includeSpinner]="false" [color]="'#000000'"></ngx-loading-bar> -->
<mat-sidenav-container class="container" autosize [hasBackdrop]="isMobile">
  <mat-sidenav #drawer class="sidenav" [mode]="isMobile ? 'over' : 'side'" [(opened)]="appService.opened"
    position="start"
    *ngIf="!planGate.blocked && currentRoute != '/login' && currentRoute != '/' && currentRoute != '/story' && currentRoute != '/developers' && currentRoute != '/mcp-guide' && currentRoute != '/recipes'"
    (backdropClick)="closeSideNav()">
    <div class="ico-menu wdd" style="
        float: left;
        display: block;
        padding: 20px 10px 20px 10px;
        box-sizing: border-box;
        position: relative;
        width: 100%;
      ">
      <img src="assets/images/buddy_head.svg" (click)="closeSideNav()"
        style="margin-top: 5px; vertical-align: text-bottom; cursor: pointer; width: 40px; height: auto;"
        matTooltip="Close menu" />

      <button [matMenuTriggerFor]="wsmenu" class="mbtn pointer" *ngIf="appService.workspaceName">
        <span>{{ appService.workspaceName }}</span>
        <mat-icon style="margin-bottom: -7px">expand_more</mat-icon>
      </button>
      <mat-menu #wsmenu="matMenu" id="menu">
        <div mat-menu-item *ngFor="let option of workspaces" class="pointer" (click)="setDefault(option.workspaceId)"
          style="width: 100%; display: block; padding-top: 4px">
          <div style="float: left">{{ option.workspaceName }}</div>
          <div *ngIf="option.default == false" style="
              font-size: 12px;
              color: #f05a37;
              margin-top: -5px;
              float: left;
              width: 100%;
            ">
            Set as default
          </div>
          <div style="float: right" *ngIf="option.workspaceName == appService.workspaceName">
            <i class="fa-solid fa-check" style="color: #15b300"></i>
          </div>
        </div>
      </mat-menu>
      <!-- <button (click)="newChat()" class="btn-primary pointer" style="float: right;"><i class="fa-regular fa-comment"></i> New Chat</button> -->
    </div>

    <div class="pr-name pointer" *ngIf="appService.get('xdbc.emailId')">
      <div class="pr-name pointer ico-user" *ngIf="appService.get('xdbc.emailId')">
        <img class="ico-userimg" src="assets/images/ico-nonp.svg" *ngIf="!appService?.image" />
        <img class="ico-userimg" src="{{ appService.image }}" *ngIf="appService?.image" />
        {{ appService.get("xdbc.emailId") }}
      </div>
    </div>

    <span>
      <ul>
        <li [routerLink]="['/read-me']" routerLinkActive="active">
          <img src="assets/images/ico-read.svg" class="mnu-icon" />Quick Start
          Guide
        </li>
        <li (click)="goToChat()" class="chat-menu-item">
          <img src="assets/images/ico-chat.svg" class="mnu-icon" />
          <span>Chat</span>
        </li>
        <li [routerLink]="['/workspace']" routerLinkActive="active">
          <img src="assets/images/ico-workspace.svg" class="mnu-icon" />
          Workspaces
        </li>
        <li [routerLink]="['/shared-workspaces']" routerLinkActive="active">
          <img src="assets/images/ico-workspace.svg" class="mnu-icon" />
          Shared
        </li>
        <li [routerLink]="['/users']" routerLinkActive="active" class="users-menu-item">
          <div class="users-menu-header" (click)="toggleUsersMenu(); $event.stopPropagation()">
            <div class="users-menu-title">
              <img src="assets/images/ico-profile.svg" class="mnu-icon" /> Users
            </div>
            <mat-icon class="expand-icon" [class.expanded]="usersExpanded">
              {{ usersExpanded ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </div>
        </li>
        <li *ngIf="usersExpanded" class="users-submenu">
          <ul class="users-list">
            <li class="view-all-users" [routerLink]="['/users']">
              <i class="fa-solid fa-table-list"></i> View All Users
            </li>
            <li *ngFor="let user of usersList" class="user-item">
              <div class="user-name">{{ user.name }}</div>
              <div class="user-actions">
                <i class="fa-solid fa-chart-line action-icon" (click)="routeUserAction(user.userkey, 'dashboard')"
                  matTooltip="Dashboard"></i>
                <i class="fa-solid fa-brain action-icon" (click)="routeUserAction(user.userkey, 'memory')"
                  matTooltip="Memory"></i>
                <i class="fa-solid fa-utensils action-icon" (click)="routeUserAction(user.userkey, 'recipe')"
                  matTooltip="Recipes"></i>
                <i class="fa-solid fa-receipt action-icon" (click)="routeUserAction(user.userkey, 'receipt')"
                  matTooltip="Receipts"></i>
                <i class="fa-solid fa-apple-whole action-icon" (click)="routeUserAction(user.userkey, 'nutrition')"
                  matTooltip="Nutrition"></i>
                <i class="fa-solid fa-bell action-icon" (click)="routeUserAction(user.userkey, 'reminder')"
                  matTooltip="Reminder"></i>
                <i class="fa-solid fa-comments action-icon" (click)="routeUserAction(user.userkey, 'chat')"
                  matTooltip="Chat"></i>
              </div>
            </li>
            <li *ngIf="usersList.length === 0" class="no-users">
              No users found
            </li>
          </ul>
        </li>
        <!--<li [routerLink]="['/lab']" routerLinkActive="active">
          <img src="assets/images/ico-lab.svg" class="mnu-icon" /> XD Chat
        </li>
        
        <li [routerLink]="['/memories']" routerLinkActive="active">
          <img src="assets/images/ico-memories.svg" class="mnu-icon" /> Memories
        </li>
        <li [routerLink]="['/reminders']" routerLinkActive="active">
          <img src="assets/images/ico-reminders.svg" class="mnu-icon" />
          Reminders
        </li>
        <li [routerLink]="['/api-audits']" routerLinkActive="active">
          <img src="assets/images/ico-audit.svg" class="mnu-icon" /> API Audits
        </li>-->
        <li [routerLink]="['/usage']" routerLinkActive="active">
          <img src="assets/images/ico-usage.svg" class="mnu-icon" /> Usage
        </li>
        <li [routerLink]="['/subscription']" routerLinkActive="active">
          <img src="assets/images/ico-payment.svg" class="mnu-icon" /> Subscription
        </li>
        <!-- <li [routerLink]="['/payments']" routerLinkActive="active">
          <img src="assets/images/ico-payment.svg" class="mnu-icon" /> Payments
        </li>         -->
      </ul>
    </span>

    <div style="
        position: absolute;
        bottom: 0;
        width: 88%;
        padding: 10px 0px 10px 0px;
      ">
      <!-- <div class="dmenu" id="fmenu">
        <mat-menu #ftmenu="matMenu">
          <button mat-menu-item (click)="logOut()">Logout</button>
          <mat-divider></mat-divider>
        </mat-menu>
      </div> -->
      <!-- <img src="assets/images/ico-beta.svg"> [matMenuTriggerFor]="ftmenu"-->
      <div>
        <img src="assets/images/ico-xd.svg" style="height: 25px; padding: 10px 0px" />
        <img src="assets/images/ico-logout.svg" class="pointer" (click)="logOut()" matTooltip="Logout"
          style="float: right; height: 40px" />
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content style="display: flex; flex-direction: column">
    <!-- <div *ngIf="appService.get('askbuddy-enterprise.name') && currentRoute != '/login' && !jwtservice.isTokenExpired()"> -->
    <div id="heade" class="heade"
      *ngIf="currentRoute != '/' && currentRoute != '/story' && currentRoute != '/developers' && currentRoute != '/mcp-guide'">
      <div *ngIf="!appService.opened && !planGate.blocked">
        <div class="ico-menu" style="margin: 22px 5px 0px 10px">
          <!-- CHANGED: closeSideNav() → openSideNav() -->
          <img src="assets/images/buddy_head.svg" (click)="openSideNav()" [attr.aria-label]="'Open menu'" role="button"
            tabindex="0" style="width: 40px; height: auto; cursor: pointer;" />
        </div>
      </div>

      <!-- <div class="resp-toaster" *ngIf="appService.showStaticMsg.msg " [ngClass]="{ 'resp-sucuess': appService.showStaticMsg?.success, 'resp-failure': appService.showStaticMsg?.error ,'res-warning': appService.showStaticMsg?.warning}">
   <span> {{appService.showStaticMsg.msg ? appService.showStaticMsg.msg : ''}}</span> <span style="cursor: pointer;" (click)="appService.showStaticMsg={}"><i class="fa-solid fa-xmark"></i></span>
 </div> -->

      <!-- <div class="topmenu" *ngIf="!appService.takeawayFeatureRestriction">
    <ul >
        
        <li (click)="openGuideDialog()">How To Guide</li>
        <li (click)="logOut()" *ngIf="!appService.showNav">Logout</li>
        
    </ul>
</div> -->
    </div>
    <!-- </div> *ngIf="currentRoute != '/login'"-->
    <router-outlet></router-outlet>
    <div class="chat-footer"
      *ngIf="currentRoute != '/' && currentRoute != '/story' && currentRoute != '/developers' && currentRoute != '/mcp-guide'">
      <div style="display: flex; justify-content: center">


        <p style="margin: 0px; color: #5d5d5d; font-size: 14px">
          Check our
          <a style="text-decoration: none; cursor: pointer; color: #1b8a9e" [href]="links.terms" target="_blank"
            rel="noopener noreferrer">Terms of Use</a>
          and
          <a style="text-decoration: none; cursor: pointer; color: #1b8a9e" [href]="links.privacy" target="_blank"
            rel="noopener noreferrer">Privacy Policy</a>
          for essential details, or visit
          <a style="text-decoration: none; cursor: pointer; color: #1b8a9e" [href]="links.support" target="_blank"
            rel="noopener noreferrer">Support</a>.
        </p>


      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>